<template>
  <router-view></router-view>
</template>

<script>
import Navbar from "@/components/base/Navbar.vue";
import store from "./store";
import router from "./router";

import { mapActions, mapGetters } from "vuex";
export default {
  name: "app",
  components: {
    Navbar
  },
  beforeCreate() {},
  beforeRouteEnter(to, from, next) {},
  computed: {
    // The user is automatically set by the feathers-vuex auth module upon login.
    /*
    user() {
      return this.$store.state.auth.user
    }
    */
  },
  watch: {
    // When the user is set, redirect to the Chat page.
    /*
    user(newVal) {
      if (newVal === undefined) {
        this.$router.replace({
          name: 'Login'
        })
      }
    }
    */
  },
  methods: {},
  created() {
    this.$toastr.defaultProgressBar = false;
    //this.$toastr.defaultTimeout = 1000000;
  },
  mounted() {}
};
</script>

<style lang="less">
</style>
